import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export const adminTableColumns = [
  { field: "_id", headerName: "ID", width: 200 },
  {
    field: "profilePicture",
    headerName: "Profile Picture",
    width: 100,
    renderCell: (params) => (
      <img
        src={`http://localhost:5000/${params.value}`}
        alt="Profile"
        style={{ width: 40, height: 40, borderRadius: "50%", margin: "5px" }}
      />
    ),
  },
  {
    field: "firstName",
    headerName: "First Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "lastName",
    headerName: "Last Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "age",
    headerName: "Age",
    type: "number",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
  },
];

export const studentTableColumns = [
  { field: "_id", headerName: "ID", width: 200 },
  {
    field: "profilePicture",
    headerName: "Profile Picture",
    width: 100,
    renderCell: (params) => (
      <img
        src={`http://localhost:5000/${params.value}`}
        alt="Profile"
        style={{ width: 40, height: 40, borderRadius: "50%", margin: "5px" }}
      />
    ),
  },
  {
    field: "firstName",
    headerName: "First Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "lastName",
    headerName: "Last Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
  },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    flex: 1,
  },
  {
    field: "age",
    headerName: "Age",
    type: "number",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "cnic",
    headerName: "CNIC",
    type: "number",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "department",
    headerName: "Department",
    type: "string",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "section",
    headerName: "Section",
    type: "string",
    headerAlign: "center",
    align: "center",
  },
];

export const techerTableColumns = [
  { field: "_id", headerName: "ID", width: 200 },
  {
    field: "profilePicture",
    headerName: "Profile Picture",
    width: 100,
    renderCell: (params) => (
      <img
        src={`http://localhost:5000/${params.value}`}
        alt="Profile"
        style={{ width: 40, height: 40, borderRadius: "50%", margin: "5px" }}
      />
    ),
  },
  {
    field: "firstName",
    headerName: "First Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "lastName",
    headerName: "Last Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
  },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    flex: 1,
  },
  {
    field: "cnic",
    headerName: "CNIC",
    type: "string",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "qualification",
    headerName: "Qualification",
    type: "string",
    headerAlign: "center",
    align: "center",
  },
];

export const departmentTableColumns = [
  { field: "_id", headerName: "ID", width: 300 },
  { field: "name", headerName: "Name", width: 500 },
  {
    field: "action",
    headerName: "Action",
    width: 250,
    renderCell: (params) => (
      <>
        <Tooltip title="Edit">
          <IconButton sx={{ background: 'blue', mx: '5px' }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton sx={{ background: 'red' }}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    ),
  },
];

export const sectionTableColumns = [
  { field: "_id", headerName: "ID", width: 300 },
  { field: "name", headerName: "Name", width: 500 },
  {
    field: "action",
    headerName: "Action",
    width: 250,
    renderCell: (params) => (
      <>
        <Tooltip title="Edit">
          <IconButton sx={{ background: 'blue', mx: '5px' }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton sx={{ background: 'red' }}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    ),
  },
];

export const InvoiceTableColumns = [
  { field: "id", headerName: "ID" },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "phone",
    headerName: "Phone Number",
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
  },
  {
    field: "cost",
    headerName: "Cost",
    flex: 1,

    cellClassName: "name-column--cell",
  },
  {
    field: "date",
    headerName: "Date",
    flex: 1,
  },
];

export const contactTableColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "registrarId", headerName: "Registrar ID" },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "age",
    headerName: "Age",
    type: "number",
    headerAlign: "left",
    align: "left",
  },
  {
    field: "phone",
    headerName: "Phone Number",
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
  },
  {
    field: "address",
    headerName: "Address",
    flex: 1,
  },
  {
    field: "city",
    headerName: "City",
    flex: 1,
  },
  {
    field: "zipCode",
    headerName: "Zip Code",
    flex: 1,
  },
];
